import { render, staticRenderFns } from "./IsyeriDetay.vue?vue&type=template&id=cb629234"
import script from "./IsyeriDetay.vue?vue&type=script&lang=ts"
export * from "./IsyeriDetay.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports